import { useEffect, useRef } from 'react';

import type { ExtendedIndexUIState } from '#src/components/search/InstantSearch/types.tsx';
import { useVirtualToggleManager } from '#src/hooks/useVirtualToggleManager.ts';

export const InitialVirtualToggleHandler = ({
  initialIndexUIState,
}: {
  initialIndexUIState: ExtendedIndexUIState;
}) => {
  const defaultStateProcessed = useRef(initialIndexUIState === undefined);
  const setVirtualToggle = useVirtualToggleManager();

  useEffect(() => {
    if (!defaultStateProcessed.current) {
      defaultStateProcessed.current = true;
      setVirtualToggle({ ...initialIndexUIState.virtualToggle }, false);
    }
  }, [setVirtualToggle, initialIndexUIState]);

  return null;
};
